import type {GetUnlockInfo_unlockInfo as UnlockInfo} from 'nutshell-graphql-types';

export const VISITOR_IQ_URL_BLOCKLIST_INFO_TEXT =
    'Add a full URL that starts with https://, including the domain and any path you need. For example, https://www.example.com/careers.';

/** Returns null if valid; otherwise a user-facing error message. */
export function isValidUrlInput(value: string): string | null {
    const trimmed = value.trim();
    if (!trimmed) {
        return null;
    }

    if (/\s/.test(trimmed)) {
        return 'URLs cannot contain spaces';
    }

    if (!/^https:\/\//i.test(trimmed)) {
        return 'Enter a full URL starting with https:// (e.g. https://example.com/careers)';
    }

    try {
        const parsed = new URL(trimmed);

        if (parsed.hostname && parsed.hostname.includes('.')) {
            return null;
        }
    } catch {
        // fall through
    }

    return 'Enter a valid full URL starting with https:// (e.g. https://example.com/careers)';
}

export function getVisitorIQUnlockStatus(unlockInfo: UnlockInfo) {
    if (unlockInfo.unlockedThisMonth >= unlockInfo.unlockLimit) {
        return {level: 'alert', text: 'Limit reached'};
    } else if (unlockInfo.unlockedThisMonth >= unlockInfo.unlockLimit - 2) {
        return {level: 'warning', text: 'Nearing limit'};
    } else {
        return {level: 'success', text: 'Credits remaining'};
    }
}

export function getStatusSecondaryText(unlockInfo: UnlockInfo): string {
    return `You’ve used ${unlockInfo.unlockedThisMonth} of your ${unlockInfo.unlockLimit} credits this month`;
}
